import * as cx from 'classnames';
import map from 'lodash-es/map';
import Popover from 'mk/common/components/Popover';
import { jQuery as $ } from 'mk/jQuery';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface OwnProps {
    sets: {
        [name: string]: any;
    };
    opened: boolean;

    getItem(item): React.ReactElement<any>;
    getSetItem?(set);
    onSelect?(item);
    onPickedSet?(set);
}

interface State {
    pickedSet: string | number;
    bottom: boolean;
}

export class Picker extends React.Component<OwnProps, State> {

    public static defaultProps = {
        opened: false,
    };

    constructor(props: OwnProps, context) {
        super(props, context);

        this.state = {
            pickedSet: Object.keys(props.sets)[0],
            bottom: false,
        };
    }

    public componentDidUpdate(prevProps) {
        if (!prevProps.opened && this.props.opened) {
            const $picker = $(ReactDOM.findDOMNode(this));
            let topOffset = $picker.offset().top;
            const $pickerLimiter = $picker.closest('.picker-limiter');
            if ($pickerLimiter.length) {
                topOffset -= $pickerLimiter.offset().top;
            }
            if (topOffset < 0 && !this.state.bottom) {
                // TODO: Can we rewrite this to not set state inside didUpdate? Use props? Presentional vs container components
                this.setState({
                    bottom: true,
                });
            }
        } else if (prevProps.opened && !this.props.opened) {
            // TODO: Can we rewrite this to not set state inside didUpdate? Use props? Presentional vs container components
            this.setState({
                bottom: false,
            });
        }
    }

    public render() {
        const {sets, opened} = this.props;
        const {pickedSet, bottom} = this.state;

        if (!opened) { return null; }
        return (
            <Popover className={cx('picker', 'picked-set', bottom && 'to-bottom')} placement="top">
                <div className="picker-content">
                    <div className="picker-items">
                        {map(sets[pickedSet], (item) => {
                            const addProps = {
                                key: item,
                                className: 'picker-item',
                                onClick: () => this.selectItem(item),
                            };
                            return React.cloneElement(this.getItem(item), addProps);
                        })}
                    </div>
                    <div className="picker-sets">
                        {map(sets, (items, set) => {
                            const addProps = {
                                key: set,
                                className: cx('picker-set-item', set === pickedSet ? 'picked' : ''),
                                onClick: () => this.pickSet(set),
                            };
                            return React.cloneElement(this.getSetItem(items[0]), addProps);
                        })}
                    </div>
                </div>
                <div className="trigger-arrow" />
            </Popover>
        );
    }

    private pickSet = (set) => {
        this.setState({pickedSet: set});
        if (this.props.onPickedSet) {
            this.props.onPickedSet(set);
        }
    };

    private selectItem = (item) => {
        if (this.props.onSelect) {
            this.props.onSelect(item);
        }
    };

    private getItem = (item) => {
        return this.props.getItem(item);
    };

    private getSetItem = (set) => {
        return this.props.getSetItem ? this.props.getSetItem(set) : this.props.getItem(set);
    };

}
